import { useMutation, UseMutationResult, useQueryClient } from "react-query";
import { API, CustomAxiosError } from "../../../../../logics/api-config";

export interface UpdateBillingDataPayload {
    billing_id: number;
    cisco_id?: string | null;
    name: string;
    address: string | null;
    city: string | null;
    zip: string | null;
    province: string | null;
    vat: string | null;
    tax_id: string | null;
    payment_code: string;
    payment_method: string;
    unique_email: string | null;
}

const useApiUpdateBillingData = (
    invalidateKeys?: (string | number)[]
): UseMutationResult<void, CustomAxiosError, UpdateBillingDataPayload, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<void, CustomAxiosError, UpdateBillingDataPayload>(
        async ({ billing_id, ...data }) => {
            const payload = {
                cisco_id: data.cisco_id,
                company_name: data.name,
                address: data.address,
                city: data.city,
                zip: data.zip,
                province: data.province,
                vat: data.vat,
                tax_id: data.tax_id,
                payment_code: data.payment_code,
                payment_method: data.payment_method,
                unique_email: data.unique_email
            };
            await API.put(`/accounting/billing-data/${billing_id}`, payload);
        },
        {
            onSuccess: async () => {
                // Invalidate or refetch provided keys if any
                if (invalidateKeys && invalidateKeys.length > 0) {
                    await queryClient.invalidateQueries(invalidateKeys);
                } else {
                    await Promise.all([
                        queryClient.invalidateQueries(["getAccountingStripeRecap"]),
                        queryClient.invalidateQueries(["getAccountingCashRecap"]),
                        queryClient.invalidateQueries(["getAccountingBookingRecap"]),
                        queryClient.invalidateQueries(["getBillingData"]),
                    ]);
                }
            },
        }
    );
};

export default useApiUpdateBillingData;
